var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogologipulse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.998,
    height: 32,
    viewBox: "0 0 127.998 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#10aee5;}.b{fill:#22304d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48 -120)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M359.662,475.351c-12.6,0-16,3.4-16,16s3.4,16,16,16,16-3.4,16-16S372.261,475.351,359.662,475.351Zm9.49,10.782-1.959,7.324a.293.293,0,0,1-.359.208l-2.332-.624a.293.293,0,0,1-.207-.359l.528-1.973a.3.3,0,0,0-.432-.331l-3.225,1.866,0,3.727a.294.294,0,0,0,.5.208l1.444-1.446a.293.293,0,0,1,.416,0l1.707,1.705a.293.293,0,0,1,0,.415l-5.357,5.364a.293.293,0,0,1-.415,0l-5.364-5.357a.3.3,0,0,1,0-.416l1.7-1.707a.293.293,0,0,1,.416,0l1.446,1.443a.293.293,0,0,0,.5-.208l0-3.726-3.229-1.861a.293.293,0,0,0-.43.33l.531,1.974a.3.3,0,0,1-.207.361l-2.33.626a.294.294,0,0,1-.361-.207l-1.966-7.322a.293.293,0,0,1,.207-.36l7.322-1.967a.294.294,0,0,1,.359.208l.626,2.33a.294.294,0,0,1-.207.36l-1.973.53a.294.294,0,0,0-.07.538l3.229,1.861,3.225-1.866a.293.293,0,0,0-.071-.538l-1.973-.528a.293.293,0,0,1-.209-.359l.623-2.331a.3.3,0,0,1,.36-.209l7.324,1.959A.294.294,0,0,1,369.152,486.133Z",
    transform: "translate(-295.662 -355.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H3V18H0Z",
    transform: "translate(85.999 124.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M409.756,490.517c-3.69,0-6,2.31-6,6s2.31,6,6,6,6-2.31,6-6S413.446,490.517,409.756,490.517Zm0,9a3,3,0,1,1,3-3A2.789,2.789,0,0,1,409.756,499.516Z",
    transform: "translate(-313.357 -359.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M434.748,496.516c0-3.689-2.31-6-6-6s-6,2.31-6,6,2.31,6,6,6a6.98,6.98,0,0,0,2.687-.5c-.064,1.712-1.5,2.666-3.477,2.666a8.352,8.352,0,0,1-4.19-1.125V506.3a10.733,10.733,0,0,0,4.669,1.013c3.311,0,6.311-1.847,6.311-5.968Zm-6,3a3,3,0,1,1,3-3A2.789,2.789,0,0,1,428.748,499.516Z",
    transform: "translate(-318.949 -359.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H3V11.6H0Z",
    transform: "translate(117.599 130.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2,0A2,2,0,1,1,0,2,2,2,0,0,1,2,0Z",
    transform: "translate(117.113 125.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M455.11,490.517c-3.69,0-6,2.31-6,6v10.8h3V501.88a6.8,6.8,0,0,0,3,.636c3.69,0,6-2.31,6-6S458.8,490.517,455.11,490.517Zm0,9a3,3,0,1,1,3-3A2.789,2.789,0,0,1,455.11,499.516Z",
    transform: "translate(-326.712 -359.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M479.67,490.8h-3l-.006,5.8c0,1.845-.806,3-2.5,3s-2.5-1.155-2.5-3v-5.8h-3v5.8c0,3.69,2.117,6,5.5,6s5.5-2.31,5.5-6Z",
    transform: "translate(-332.471 -359.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H3V18H0Z",
    transform: "translate(148.998 124.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M496.331,493.918c0-.854,1.31-.9,2.061-.9a8.167,8.167,0,0,1,4.068,1.157v-2.692a9.924,9.924,0,0,0-4.285-.969c-2.445,0-4.843.873-4.843,3.5,0,4.063,7,3.425,7,5.078,0,.748-1.238.893-2.471.893a8.85,8.85,0,0,1-4.432-1.247v2.716a9.521,9.521,0,0,0,4.625,1.063c2.785,0,5.278-.826,5.278-3.5,0-4.157-7-3.481-7-5.1",
    transform: "translate(-339.733 -359.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M517.48,495.454h-5a2.572,2.572,0,0,1,2.718-2.433,2.152,2.152,0,0,1,2.286,2.433m-2.4-4.937a5.591,5.591,0,0,0-5.593,6c0,3.945,2.853,6,6.295,6a9.952,9.952,0,0,0,3.985-.708v-2.574a7.863,7.863,0,0,1-3.283.685c-1.789,0-3.623-.685-3.985-2.338h7.811c.724-3.355-.725-7.063-5.23-7.063",
    transform: "translate(-344.49 -359.817)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogologipulse);
export default __webpack_public_path__ + "static/media/Logologipulse.b292c1691cb5e005854222d4ffb9a001.svg";
export { ForwardRef as ReactComponent };